// @flow
import * as React from 'react';
import * as ROUTES from '@routes';
import { withTranslation, Link } from '@i18n';

import { PROFILE_LOGIN } from '@routes';
import SearchBar from '@components/SearchBar/index';
import { useState } from 'react';
import NavigationDropdown from '../NavigationDropdown';
import {
  StyledButtonSignInOut, StyledSeparator, SearchIconImg, SearchImg
} from './styles';
import StyledLink from '../StyledLink';
import NavigationLink from '../NavigationLink/index';
// import FlowModal from '@components/FlowModal/index';


export const LoggedInDropdown = withTranslation('Profile')(
  ({
    t, username, pathname, doLogout
  }): React.Node => (
    <NavigationDropdown label={t('Welcome', { username })} links={[]} pathname={pathname}>
      <Link
        href={ROUTES.PROFILE_SUB_TAB}
        passHref
        params={{ primaryTab: 'default', secondaryTab: 'dashboard' }}
      >
        <StyledLink>{t('Menu.Dashboard')}</StyledLink>
      </Link>
      {/*
      <Link href={ROUTES.RECOMMENDATIONS} passHref>
        <StyledLink>{t('Menu.Recommendations')}</StyledLink>
      </Link>
      */}
      <Link href={ROUTES.PROFILE_SETTINGS} passHref>
        <StyledLink>{t('Menu.Settings')}</StyledLink>
      </Link>

      <StyledSeparator />

      <StyledLink onClick={doLogout}>{t('Menu.LogOut')}</StyledLink>
    </NavigationDropdown>
  )
);


const LoginSignInButtons = (
  {
    t,
    doLogout,
    isLoggedIn,
    username,
    invertCta,
    pathname,
    setModalOpen,
    heroSection
  }
): React.Node => {
  const [searchState, setSearchState] = useState(false);

  const handleSeachIcon = () => {
    setSearchState(!searchState);
  };

  return (

    <>
      {/* {!isLoggedIn && <LoginDropdown doLogin={doLogin} />} */}
      {isLoggedIn ? (
        <LoggedInDropdown doLogout={doLogout} username={username} pathname={pathname} />
      ) : (
        <>
          <NavigationLink label={t('Login')} route={PROFILE_LOGIN} heroSection={heroSection} />

          <SearchImg>

            <SearchIconImg onClick={handleSeachIcon} heroSection={heroSection} />
          </SearchImg>
          {searchState
        && <SearchBar setSearchState={setSearchState} /> }

          {/* <StyledButtonSignInOut inverted={invertCta} onClick={() => setModalOpen(true)}> */}
          <StyledButtonSignInOut
            inverted={invertCta}
            onClick={() => setModalOpen(true)}
            heroSection={heroSection}
          >
            {t('GetStarted')}
          </StyledButtonSignInOut>

          {/* { flow && <FlowModal />} */}
        </>
      )}

    </>
  );
};
export default withTranslation('Navigation')(LoginSignInButtons);
